import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { APICreatedCliToken } from '../../../../../../../../../typings/CliClient.interface';
import { CliKeyAccessFields, CliKeyAccessFormValues, cliKeyAccessInitialValues, toCliKeyAccessInput, validateCliKeyAccess } from '../../../../../common/ApiKeys/CliKeyAccess';
import TextInput from '../../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../../common/helpers/StyledUtils';
import Modal from '../../../../../common/Modal';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { DashboardContext } from '../../../DashboardContext';
interface FormValues extends CliKeyAccessFormValues {
  name: string;
}
interface CreateKeyModalProps {
  onClose: () => void;
  onCreated: (cli_key: APICreatedCliToken) => void;
}
const CreateKeyModal: React.FC<CreateKeyModalProps> = t0 => {
  const $ = _c(23);
  const {
    onClose,
    onCreated
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    organization,
    organizations,
    team,
    teams
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  let t1;
  if ($[0] !== teams) {
    t1 = teams ?? [];
    $[0] = teams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const projects = t1;
  let t2;
  if ($[2] !== projects) {
    t2 = values => {
      const errors = validateCliKeyAccess(values, projects);
      if (!values.name?.trim()) {
        errors.name = "Required";
      }
      return errors;
    };
    $[2] = projects;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const validate = t2;
  let t3;
  if ($[4] !== HookdeckAPI || $[5] !== addToast || $[6] !== onCreated || $[7] !== projects) {
    t3 = async values_0 => {
      ;
      try {
        const cli_key = await HookdeckAPI.session.createCliToken({
          name: values_0.name.trim(),
          ...toCliKeyAccessInput(values_0, projects)
        });
        onCreated(cli_key);
      } catch (t4) {
        const error = t4;
        addToast("error", error.response?.message || "The key could not be created, please try again.");
      }
    };
    $[4] = HookdeckAPI;
    $[5] = addToast;
    $[6] = onCreated;
    $[7] = projects;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onSubmit = t3;
  const t4 = organization?.id;
  let t5;
  if ($[9] !== t4) {
    t5 = cliKeyAccessInitialValues(t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      name: "",
      ...t5
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onClose || $[14] !== organizations || $[15] !== projects || $[16] !== team?.id) {
    t7 = props => <Form><Modal title="Create key" submit_label="Create key" cancel_label="Cancel" hide_close={true} onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose} is_submitting={props.isSubmitting} submit_disabled={!props.isValid}><Div flex={{
          direction: "column",
          gap: 0
        }}><TextInput name="name" label="Name" placeholder="e.g. Deploy script" auto_complete="off" maxlength={255} focus={true} /><CliKeyAccessFields organizations={organizations ?? []} projects={projects} current_project_id={team?.id} /></Div></Modal></Form>;
    $[13] = onClose;
    $[14] = organizations;
    $[15] = projects;
    $[16] = team?.id;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== onSubmit || $[19] !== t6 || $[20] !== t7 || $[21] !== validate) {
    t8 = <Formik initialValues={t6} onSubmit={onSubmit} validate={validate} validateOnMount={true}>{t7}</Formik>;
    $[18] = onSubmit;
    $[19] = t6;
    $[20] = t7;
    $[21] = validate;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default CreateKeyModal;